import styled from "@emotion/styled";
import * as Brand from "@emotion-icons/fa-brands";
import { Button } from "./Buttons";

const Container = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0px 16px;
  padding: 16px;
  max-width: 1440px;
  width: 100%;

  @media (min-width: 769px) {
    justify-content: flex-end;
  }
`;

const Social = () => {
  return (
    <Container>
      <Button>
        <Brand.Facebook />
      </Button>
      <Button>
        <Brand.Twitter />
      </Button>
      <Button>
        <Brand.Instagram />
      </Button>
    </Container>
  );
};

export default Social;
